export const NAME = 'CITIES';

export const cityInfo = (store) => store[NAME].info.data;
